import { Link } from 'react-router-dom';

export const TUNNEL_STYLE = `
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,700&family=Manrope:wght@400;600;700&display=swap');
.tunnel { font-family: 'Manrope', sans-serif; background: #f6f2e8; color: #17261b; }
.tunnel h1, .tunnel h2, .tunnel h3, .tunnel .serif { font-family: 'Fraunces', serif; }
.tunnel .reveal { animation: tunnelUp .7s ease both; }
@keyframes tunnelUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: none; } }
`;

export const TunnelLogo = ({ clair = false }) => (
  <Link to="/solutions" data-testid="tunnel-logo" className={`serif text-xl font-bold tracking-tight ${clair ? 'text-white' : 'text-[#12321f]'}`}>
    Bureau Agricole<span className="text-[#c9a227]">.</span>
  </Link>
);

export const TunnelHeader = ({ clair = false }) => (
  <header className={`flex items-center justify-between px-6 md:px-12 py-5 ${clair ? 'absolute inset-x-0 top-0 z-20' : ''}`}>
    <TunnelLogo clair={clair} />
    <a href="#demande" data-testid="tunnel-header-cta"
      className="rounded-full bg-[#c9a227] px-5 py-2 text-sm font-bold text-[#12321f] transition-transform hover:-translate-y-0.5">
      Demander une démo
    </a>
  </header>
);

export const International = () => (
  <section data-testid="tunnel-international" className="bg-[#12321f] text-white px-6 md:px-12 py-16">
    <div className="max-w-5xl">
      <p className="text-xs uppercase tracking-[0.25em] text-[#c9a227] mb-3">Pas seulement en France</p>
      <h2 className="text-3xl md:text-4xl mb-5">Votre langue, la réglementation de votre pays.</h2>
      <p className="text-base md:text-lg text-white/80 leading-relaxed">
        Bureau Agricole se traduit en quelques jours et s'adapte aux règles de chaque pays : registres, déclarations, facturation, normes de traçabilité.
        Valentine comprend et répond dans la langue de l'exploitant. Espagne, Italie, Portugal, Belgique, Suisse, Maghreb, Afrique de l'Ouest :
        le même outil, réglé sur la réglementation locale.
      </p>
    </div>
  </section>
);
